const BASE_CONST = `INGREDIENT_CATEGORY`;

export const INGREDIENT_CATEGORY_PAGE_REQUEST = `${BASE_CONST}_PAGE_REQUEST`;

export const INGREDIENT_CATEGORY_CATEGORIES_REQUEST = `${BASE_CONST}_CATEGORIES_REQUEST`;

export const INGREDIENT_CATEGORY_SET_OUTLETS = `${BASE_CONST}_SET_OUTLETS`;

export const INGREDIENT_CATEGORY_SET_CATEGORIES = `${BASE_CONST}_SET_CATEGORIES`;

export const INGREDIENT_CATEGORY_SET_CURRENT_PAGE = `${BASE_CONST}_SET_CURRENT_PAGE`;

export const INGREDIENT_CATEGORY_SET_TOTAL_PAGE = `${BASE_CONST}_SET_TOTAL_PAGE`;

export const INGREDIENT_CATEGORY_SET_CATEGORY_DETAIL = `${BASE_CONST}_SET_CATEGORY_DETAIL`;

export const INGREDIENT_CATEGORY_ON_CHANGE_OUTLET_IDS = `${BASE_CONST}_ON_CHANGE_OUTLET_IDS`;

export const INGREDIENT_CATEGORY_ON_CHANGE_KEYWORD = `${BASE_CONST}_ON_CHANGE_KEYWORD`;

export const INGREDIENT_CATEGORY_ON_CLICK_CREATE_CATEGORY = `${BASE_CONST}_ON_CLICK_CREATE_CATEGORY`;

export const INGREDIENT_CATEGORY_ON_CLICK_CANCEL = `${BASE_CONST}_ON_CLICK_CANCEL`;

export const INGREDIENT_CATEGORY_ON_CLICK_ROW = `${BASE_CONST}_ON_CLICK_ROW`;

export const INGREDIENT_CATEGORY_SHOW_RIGHT_COLUMN = `${BASE_CONST}_SHOW_RIGHT_COLUMN`;

export const INGREDIENT_CATEGORY_HIDE_RIGHT_COLUMN = `${BASE_CONST}_HIDE_RIGHT_COLUMN`;

export const INGREDIENT_CATEGORY_SUBMIT_FORM = `${BASE_CONST}_SUBMIT_FORM`;

export const INGREDIENT_CATEGORY_SHOW_DELETE_MODAL = `${BASE_CONST}_SHOW_DELETE_MODAL`;

export const INGREDIENT_CATEGORY_HIDE_DELETE_MODAL = `${BASE_CONST}_HIDE_DELETE_MODAL`;

export const INGREDIENT_CATEGORY_DELETE_CATEGORY = `${BASE_CONST}_DELETE_CATEGORY`;

export const INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CATEGORY = `${BASE_CONST}_ASSIGN_TO_INGREDIENT_SET_CATEGORY`;

export const INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_GET_INGREDIENTS_REQUEST = `${BASE_CONST}ASSIGN_TO_INGREDIENT_GET_INGREDIENTS_REQUEST`;

export const INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_FILL_FORM = `${BASE_CONST}ASSIGN_TO_INGREDIENT_FILL_FORM`;

export const INGREDIENT_CATEGORY_SUBMIT_ASSIGN_TO_INGREDIENT = `${BASE_CONST}SUBMIT_ASSIGN_TO_INGREDIENT`;

export const INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_TOTAL_PAGE = `${BASE_CONST}ASSIGN_TO_INGREDIENT_SET_TOTAL_PAGE`;

export const INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_CURRENT_PAGE = `${BASE_CONST}ASSIGN_TO_INGREDIENT_SET_CURRENT_PAGE`;

export const INGREDIENT_CATEGORY_ASSIGN_TO_INGREDIENT_SET_INGREDIENTS = `${BASE_CONST}ASSIGN_TO_INGREDIENT_SET_INGREDIENTS`;

export const INGREDIENT_CATEGORY_CANCEL_ASSIGN_TO_INGREDIENT = `${BASE_CONST}CANCEL_ASSIGN_TO_INGREDIENT`;

export const INGREDIENT_CATEGORY_HIDE_ASSIGN_TO_INGREDIENT_MODAL = `${BASE_CONST}HIDE_ASSIGN_TO_INGREDIENT_MODAL`;

export const INGREDIENT_CATEGORY_SHOW_ASSIGN_TO_INGREDIENT_MODAL = `${BASE_CONST}SHOW_ASSIGN_TO_INGREDIENT_MODAL`;

export const INGREDIENT_CATEGORY_ON_CLICK_ASSIGN_TO_INGREDIENT = `${BASE_CONST}ON_CLICK_ASSIGN_TO_INGREDIENT`;

export const INGREDIENT_CATEGORY_SET_IS_SUBMITTING = `${BASE_CONST}SET_IS_SUBMITTING`;
